import { createAsyncThunk } from '@reduxjs/toolkit';
import { admin_apiEndpoint, config_variable } from '../../helper/commonApi';
import { GetApiCall, ApiCall } from '../../helper/axios';

export const getSettingAsync = createAsyncThunk('fetch/getSetting', async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await GetApiCall('GET', `/get-setting?shop=${config_variable.shop_name}`, { authentication: store_data?.token })
    if (res.data.success && res.status === 200) {
        return res?.data?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

export const getMetafieldsAsync = createAsyncThunk('fetch/getMetafields', async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await GetApiCall('GET', `/metafield?shop=${config_variable.shop_name}`, { authentication: store_data?.token })
    if (res.data.success && res.status === 200) {
        return res?.data?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

export const deleteMetafieldAsync = createAsyncThunk('fetch/deleteMetafield', async (param, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await ApiCall('DELETE', `/metafield?shop=${config_variable.shop_name}&id=${param.id}`, param.payload, { authentication: store_data?.token })
    if (res.data.success && res.status === 200) {
        param.callback(res?.data?.success, res?.data?.message);
        return res?.data?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

export const updateMetafieldAsync = createAsyncThunk('fetch/updateMetafield', async (param, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await ApiCall('PUT', `/metafield?shop=${config_variable.shop_name}&id=${param.id}`, param.payload, { authentication: store_data?.token })
    if (res.data.success && res.status === 200) {
        param.callback(res?.data?.success, res?.data?.message);
        return res?.data?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

export const getFormulaAsync = createAsyncThunk('fetch/getFormula', async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await GetApiCall('GET', `/pricing-formula?shop=${config_variable.shop_name}`, { authentication: store_data?.token })
    if (res.data.success && res.status === 200) {
        return res?.data?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

